module.exports = __webpack_public_path__ + "img/leftTop.482949e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/leftTop.jpg
// module id = ./assets/images/leftTop.jpg
// module chunks = 2